module.exports = __webpack_public_path__ + "img/pic_kc@2x.789f5f85.png";